import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {connect} from 'react-redux';

import CadminApi    from 'app/apis/company-admin';
import Modal        from 'app/components/common/modal';
import WorkflowCard from 'app/components/company-admin/grant-system/workflow-card';
import GrantSysDuck from 'app/ducks/company-admin/grant-system';
import paths        from 'app/paths';
import history      from 'app/history';
import CadminSlx    from 'app/selectors/company-admin/';

class ModalNewWorkflow extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      createPending: false,
      workflows: null,
      selectedWfId: null,
    };

    this.onClickWorkflow = this.onClickWorkflow.bind(this);
    // this.onClickFromTemplate = this.onClickFromTemplate.bind(this);
    this.onClickCreate = this.onClickCreate.bind(this);
  }

  get isTemplate() {
    return !this.props.programId;
  }

  get workflows() {
    const {company} = this.props;
    const {isTemplate} = this;
    const wfs = this.state.workflows;
    if (!wfs) return null;
    return wfs.filter((wf) => {
      const isOwn = wf.companyId === company.id;
      return isTemplate ? !isOwn : isOwn;
    });
  }

  get saveParams() {
    const params = {};
    if (this.props.programId) params.grantProgramId = this.props.programId;
    if (this.state.selectedWfId) params.grantWorkflowId = this.state.selectedWfId;
    return params;
  }

  componentDidMount() {
    this.fetchTemplates();
  }

  fetchTemplates() {
    this.props.fetchTemplates().then(({grantWorkflows}) => {
      this.setState({workflows: grantWorkflows});
    });
  }

  onClickWorkflow(workflow) {
    this.setState((prevState) => {
      const isSame = prevState.selectedWfId === workflow.id;
      const selectedWfId = isSame ? null : workflow.id;
      return {selectedWfId};
    });
  }

  onClickCreate() {
    this.setState({createPending: true});
    CadminApi.grantWorkflowsCreate(this.props.company.id, this.saveParams).then(({grantWorkflow}) => {
      this.setState({createPending: false});
      const path = paths.cadminGrantWorkflowsEdit(this.props.company.slug, grantWorkflow.id);
      history.push(path);
    });
  }

  renderTemplates() {
    const wfs = this.workflows;
    const {selectedWfId, createPending} = this.state;
    if (!wfs) return <p>loading...</p>;
    if (!wfs.length) return <p>No templates to choose from yet.</p>;
    const btnDisabled = !selectedWfId || createPending;

    return (<>
      <div className="ca-modal-select-gwft-con">
        {wfs.map((wf) => {
          const isSelected = wf.id === this.state.selectedWfId;
          const selectedClass = isSelected ? 'selected' : '';
          return (
            <WorkflowCard key={wf.id} workflow={wf} onClick={this.onClickWorkflow} className={`ca-modal-select-gwft-gwf ${selectedClass}`} />
          );
        })}
      </div>
      <div className="bform-actions">
        <div className="bform-actions-right">
          <button className="btn blue" onClick={this.onClickCreate} disabled={btnDisabled}>{createPending ? 'Creating...' : 'Use Selected Template'}</button>
        </div>
      </div>
    </>);
  }

  render() {
    const {createPending} = this.state;
    const title = this.isTemplate ? 'New Workflow Template' : 'Setup Workflow';
    const startText = this.isTemplate ? 'Start with a system template' : 'Start with a library template';

    return (
      <Modal onClose={this.props.onClose} className="bform ca-modal-select-gwft">
        <h1 className="bform-h1">{title}</h1>
        <h2 className="bform-h2">{startText}</h2>
        {this.renderTemplates()}

        <h2 className="bform-h2">Or, start from scratch</h2>
        <div className="bform-actions">
          <div className="bform-actions-right">
            <button className="btn blue" onClick={this.onClickCreate} disabled={createPending}>{createPending ? 'Creating...' : 'Start from Scratch'}</button>
          </div>
        </div>
      </Modal>
    );
  }

}

ModalNewWorkflow.propTypes = {
  onClose: PropTypes.func.isRequired,
  programId: PropTypes.string,
};
ModalNewWorkflow.defaultProps = {};

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
});
const dispatchToProps = (dispatch) => ({
  fetchTemplates: () => dispatch(GrantSysDuck.Ax.workflowsFetchTemplates(undefined)),
});

export default connect(stateToProps, dispatchToProps)(ModalNewWorkflow);
